import { useContext, useMemo, useRef } from 'react'
import { AppContext } from '@/core/lifecycle/AppContext'
import type { DiId } from '../di/di-ids'
import { log } from '../errors/log-utils'

export function useDiRef<T>(diId: DiId): T {
  const appContainer = useContext(AppContext)!

  const ref = useRef<T | undefined>(undefined)
  // if (diId === 'NewItemButtonController') {
  //   log('useDiRef', { current: ref.current, diId })
  // }
  if (!ref.current) {
    ref.current = appContainer[diId] as T
  }

  return ref.current
}

export function useTransientDiRef<T>(diId: DiId, init?: (t: T) => void): T {
  const appContainer = useContext(AppContext)!

  // strict mode does not reset ref for simulated remounts
  // https://github.com/facebook/react/issues/24670
  return useMemo(() => {
    const factory = appContainer[diId] as () => T
    const instance = factory()
    if (init) {
      init(instance)
    }
    return instance
  }, [])
}
